module.exports = __webpack_public_path__ + "ki.b76fb20a7a6178f43e75.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ki.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ki.svg
// module chunks = styles